var _path, _g, _rect, _rect2, _path2, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 121,
    viewBox: "0 0 127 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 47C1.5 45.741 2.09278 44.5554 3.1 43.8L59.1 1.8C60.5222 0.733334 62.4778 0.733333 63.9 1.8L119.9 43.8C120.907 44.5554 121.5 45.741 121.5 47V110.5C121.5 114.918 117.918 118.5 113.5 118.5H9.5C5.08172 118.5 1.5 114.918 1.5 110.5V47Z",
    fill: "url(#paint0_linear_516_11161)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_516_11161)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.001,
    y: 26,
    width: 95,
    height: 84,
    rx: 4,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.999,
    y: 67.5001,
    width: 55,
    height: 6,
    rx: 3,
    fill: "#E1E6EE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33.999,
    y: 78.5,
    width: 55,
    height: 6,
    rx: 3,
    fill: "#E1E6EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 45.0065C1.5 44.8478 1.57531 44.6986 1.70295 44.6043L2.87404 43.7394C3.0632 43.5996 3.32416 43.6106 3.50091 43.7658L61.1702 94.3811C61.3589 94.5467 61.6411 94.5467 61.8298 94.3811L119.499 43.7658C119.676 43.6106 119.937 43.5996 120.126 43.7394L121.297 44.6043C121.425 44.6986 121.5 44.8478 121.5 45.0065V110.5C121.5 114.918 117.918 118.5 113.5 118.5H9.5C5.08172 118.5 1.5 114.918 1.5 110.5V45.0065Z",
    fill: "url(#paint1_linear_516_11161)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_516_11161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 111L59.7175 81.4062C60.8398 80.8357 62.1652 80.8269 63.295 81.3824L121.5 110V110.5C121.5 114.918 117.919 118.5 113.5 118.5H9.00001C4.85787 118.5 1.5 115.142 1.5 111Z",
    fill: "url(#paint2_linear_516_11161)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_516_11161)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 61.499,
    cy: 37.0002,
    r: 25,
    fill: "url(#paint3_linear_516_11161)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_516_11161)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.0364 30.2695C73.7874 31.0205 73.7874 32.2381 73.0364 32.9891L60.5832 45.4423C59.4952 46.5303 57.7313 46.5303 56.6434 45.4423L49.9594 38.7584C49.2084 38.0074 49.2084 36.7897 49.9594 36.0387C50.7104 35.2877 51.9281 35.2877 52.6791 36.0387L57.1784 40.538C57.9709 41.3305 59.2557 41.3305 60.0482 40.538L70.3167 30.2695C71.0677 29.5185 72.2853 29.5185 73.0364 30.2695Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_516_11161",
    x: 8.75098,
    y: 20.75,
    width: 105.5,
    height: 94.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.625
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788347 0 0 0 0 0.818459 0 0 0 0 0.878681 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_516_11161"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_516_11161",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_516_11161",
    x: 0.5,
    y: 76.972,
    width: 126,
    height: 43.528,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_516_11161"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_516_11161",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_516_11161",
    x: 28.9776,
    y: 7.23954,
    width: 69.0428,
    height: 69.0428,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4.76071
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.76071
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.90864 0 0 0 0 0.363456 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_516_11161"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_516_11161",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_516_11161",
    x: 44.6358,
    y: 27.3258,
    width: 33.7245,
    height: 26.0735,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.38035
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.38035
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0283818 0 0 0 0 0.829026 0 0 0 0 0.348639 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_516_11161"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_516_11161",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_516_11161",
    x1: 61.9255,
    y1: 0,
    x2: 61.9255,
    y2: 118.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625356,
    stopColor: "#CCD4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD4E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_516_11161",
    x1: 6.0283,
    y1: 77.1121,
    x2: 119.831,
    y2: 102.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0095307,
    stopColor: "#EBEDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22516,
    stopColor: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDE2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_516_11161",
    x1: 53.5755,
    y1: 83.5,
    x2: 56.8009,
    y2: 126.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0095307,
    stopColor: "#F9FAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374871,
    stopColor: "#E9ECF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D8E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_516_11161",
    x1: 76.5934,
    y1: 52.4571,
    x2: 47.7505,
    y2: 14.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24C791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFF7EF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.e636108c1e742d7649288f9afefa0529.svg";
export { ForwardRef as ReactComponent };